export const columns = [
    {
        title: 'Keywords',
        sortable: false,
        key: 'keyword',
        width: '20%',
    },
    {
        title: 'Bid Amount',
        sortable: true,
        key: 'bidAmount',
        width: '15%',
    },
    {
        title: 'Match Type',
        sortable: false,
        key: 'matchType',
        width: '12%',
    },
    {
        title: 'Spend',
        sortable: true,
        width: '12%',
        key: 'spend',
    },
    {
        title: 'Impressions',
        sortable: true,
        width: '15%',
        key: 'impressions',
    },
    {
        title: 'Cart Additions',
        sortable: true,
        width: '10%',
        key: 'addToCart',
    },
    {
        title: 'GMV',
        sortable: true,
        width: '10%',
        key: 'gmv',
    },
    {
        title: 'ROI',
        sortable: true,
        width: '10%',
        key: 'roi',
    },
];
